import { Drawer, Grid, Layout } from "antd";
import { AppSuspense } from "components/App/AppSuspense";
import { AuthProvider } from "provider/AuthProvider";
import { useCallback, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { PageBreadcrumb } from "./components/PageBreadcrumb";
import {
  SIDENAV_WIDTH,
  SIDENAV_WIDTH_COLLAPSED,
  Sidebar,
  SidebarMenu,
} from "./components/Sidebar";
import "./styles/AdminLayout.scss";

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const AdminLayout = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [collapsed, setCollapsed] = useState(false);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [siteLayoutMarginLeft, setSiteLayoutMarginLeft] =
    useState(SIDENAV_WIDTH);

  const toggle = useCallback(() => {
    if (isMobile) {
      setMobileDrawerOpen((prev) => !prev);
      return;
    }

    setCollapsed((prev) => !prev);
  }, [isMobile]);

  const closeMobileDrawer = useCallback(() => {
    setMobileDrawerOpen(false);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setSiteLayoutMarginLeft(0);
      return;
    }

    setMobileDrawerOpen(false);
    setSiteLayoutMarginLeft(
      collapsed ? SIDENAV_WIDTH_COLLAPSED : SIDENAV_WIDTH,
    );
  }, [collapsed, isMobile]);

  return (
    <AppSuspense>
      <AuthProvider>
        <Layout>
          {!isMobile && <Sidebar collapsed={collapsed} />}

          <Drawer
            title={null}
            placement="left"
            closable={false}
            onClose={closeMobileDrawer}
            open={isMobile && mobileDrawerOpen}
            width={SIDENAV_WIDTH}
            className="admin-sidebar-drawer"
            styles={{ body: { padding: 0 } }}
          >
            <SidebarMenu collapsed={false} onNavigate={closeMobileDrawer} />
          </Drawer>

          <Layout
            className={`site-layout${isMobile ? " site-layout--mobile" : ""}`}
            style={{ marginLeft: siteLayoutMarginLeft }}
          >
            <Navbar
              collapsed={isMobile ? true : collapsed}
              toggle={toggle}
              isMobile={isMobile}
            />

            <PageBreadcrumb />

            <Content className="site-layout-background admin-page-content">
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </AuthProvider>
    </AppSuspense>
  );
};
